import React, {Component} from 'react'
import '../scss/Title.scss';
import {Divider} from 'antd';

export class Title extends Component {
  render() {
    const {type} = this.props

    var day1 = new Date();
    day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
    var s1 = day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
    switch (type) {
      case 0:
        return <div><h4 className="title">{this.props.title}</h4></div>
  break;
      case 1:
        return <h3 className="title"><span>{this.props.title1}</span>{this.props.title2}</h3>
        break;
      case 2:
        return <span><h3 className="title pull-left">{this.props.title}</h3><h4 className="pull-left font-size-14 margin-l-15" style={{'marginTop':'25px'}}>数据更新于{s1}</h4></span>
        break;
      default:
        return <h2 className="title">{this.props.title}</h2>
        break;
    }
  }
}

export default Title
